module.exports = __webpack_public_path__ + "res/ic_add.c6a9cdadb7b9171924149f3fe10b7551.png";